// Vuex user module main file
import actions from './actions';
import mutations from './mutations';
import agent from './agent';
import supervisors from './supervisors';
import faq from './faq';

const INITIAL_STATE = {
  details: {
    record: {},
    total: 0,
  },
};

const getters = {
  details: state => state.details,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
  modules: {
    agent,
    supervisors,
    faq,
  },
};

export default Module;
